import XUIActions from '@xero/xui/react/actions';
import XUIButton from '@xero/xui/react/button';
import { XUIPanelSection } from '@xero/xui/react/panel';
import { FC, ReactNode, useState } from 'react';
import './NavPanelSection.css';

export interface INavPanelSectionProps {
    onSubmitClick: () => void;
    onCancelClick: () => void;
    submitContent: ReactNode;
    cancelContent: ReactNode;
    fullWidth: boolean;
    isSubmitEnabled: boolean;
    isSaving: boolean;
}

export const NavPanelSection: FC<INavPanelSectionProps> = ({ onSubmitClick, onCancelClick, ...props }) => {
    const navItemClassName = `${!props.fullWidth ? 'content ' : ''}xui-padding-bottom-large`;
    const [cancelDisabled, setCancelDisabled] = useState(false);
    const handleCancelClick = () => {
        setCancelDisabled(true);
        onCancelClick.call(this);
    };
    return (
        <XUIPanelSection className='nav-panel-section xui-padding-right-large xui-padding-top-large'>
            <div className={navItemClassName}>
                <XUIActions
                    primaryAction={
                        <XUIButton
                            qaHook='settings-save'
                            isDisabled={!props.isSubmitEnabled}
                            isLoading={props.isSaving}
                            loadingAriaLabel='Loading'
                            onClick={onSubmitClick}
                            variant='main'
                        >
                            {props.submitContent}
                        </XUIButton>
                    }
                    secondaryAction={
                        <XUIButton
                            qaHook='settings-cancel'
                            onClick={handleCancelClick}
                            variant='standard'
                            isDisabled={cancelDisabled}
                        >
                            {props.cancelContent}
                        </XUIButton>
                    }
                />
            </div>
        </XUIPanelSection>
    );
};
